// Libs
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Container, Nav } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import UserService from 'services/UserService';
import DOMHelpers from 'helpers/DOMHelpers';

// Components
import Loader from 'components/common/Loader';
import EditUserModal from 'components/admin/users/EditUserModal';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class UsersPage extends React.Component {

    constructor(props) {
        super(props);

        this.editUserModalRef = React.createRef();

        this.requestID = 1;
        this.roles = [];
        this.state = {
            isLoading: true
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        GlobalStateService.setValues({
            area: 'users'
        });
        this.load();

        // Get role list
        const loginInfo = GlobalStateService.getValue('loginInfo');
        this.roles = [];
        this.roles.push({ id: 'Accountant', name: 'Accountant' });
        if (loginInfo.isSiteAdmin) {
            this.roles.push({ id: 'Admin', name: 'Admin' });
        }
        this.roles.push({ id: 'Vendor', name: 'Vendor' });
        this.roles.push({ id: 'Instructor', name: 'Instructor' });
        this.roles.push({ id: 'Manager', name: 'Manager' });
        this.roles.push({ id: 'InstructorManager', name: 'Instructor & Manager' });
    }

    async componentDidUpdate(oldProps) {
        if (this.props.match.params.role != oldProps.match.params.role) {
            this.load();
        }
    }

    async load() {
        this.setState({
            isLoading: true
        });
        const role = this.props.match.params.role;
        let users;
        if (role) {
            users = await UserService.list({
                role
            });
        }
        this.setState({
            users,
            isLoading: false
        });
    }

    async editUser(user) {
        await this.editUserModalRef.current.show({
            userID: user.id
        });
        this.load();
    }

    async addUser() {
        await this.editUserModalRef.current.show({
            role: this.props.match.params.role
        });
        this.load();
    }

    render() {
        return (<>
            <div className="page users-page">

                <PageHeader>
                    <h1>Users</h1>

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.addUser()}>
                            <span className="fa-solid fa-plus"></span>{' '}
                            New user
                        </button>

                    </div>

                </PageHeader>

                <main>

                    <Container>

                        <section>

                            {this.renderNav()}

                        </section>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditUserModal ref={this.editUserModalRef} />

        </>);

    }

    renderNav() {
        const role = this.props.match.params.role;

        return (
            <Nav variant="pills">
                {this.roles.map(r =>
                    <Nav.Item key={r.id}>
                        <Link
                            className={'nav-link ' + (r.id == role ? 'active' : '')}
                            to={'/users/' + r.id}
                            onClick={e => DOMHelpers.scrollToMiddle(e.target)}
                        >
                            {r.name}
                        </Link>
                    </Nav.Item>
                )}
            </Nav>
        );
    }

    renderInner() {
        const {
            isLoading,
            users
        } = this.state;
        const role = this.props.match.params.role;
        const roleInfo = this.roles.find(r => r.id == role);

        if (isLoading) {
            return (<Loader />);
        }
        if (!role || !users) {
            return (
                <div className="empty-text">
                    Please select a user role
                </div>
            );
        }
        
        return (
            <div className="sticky-table-container scrolling">
                <table className="table table-bordered sticky-table selectable users-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Last activity</th>
                            <th>Geos</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map(u =>
                            <tr key={u.id} onClick={e => this.editUser(u)}>
                                <td>{u.firstName} {u.lastName}</td>
                                <td>{u.email}</td>
                                <td>{u.lastActivityDate ? moment(u.lastActivityDate).format('DD/MM/YYYY') : ''}</td>
                                <td>{u.geoNames.join(', ')}</td>
                                <td>{u.notes.map(n => <div key={n}>{n}</div>)}</td>
                            </tr>
                        )}
                    </tbody>
                    {users.length == 0 && 
                        <tfoot>
                            <tr>
                                <td colSpan="5" className="empty-text">
                                    No {roleInfo ? roleInfo.name : role} users found
                                </td>
                            </tr>
                        </tfoot>
                    }
                </table>
            </div>
        );
    }
}

export default withRouter(UsersPage);